import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "margin-h3" }
const _hoisted_2 = { class: "subgrid gap-04 mtop-02" }
const _hoisted_3 = { class: "bg-modal w-maxC" }
const _hoisted_4 = { class: "bg-modal w-maxC" }
const _hoisted_5 = { class: "margin-h3 mtop-10" }
const _hoisted_6 = { class: "subgrid gap-04 mtop-02" }
const _hoisted_7 = { class: "margin-h3 mtop-10" }
const _hoisted_8 = { class: "subgrid gap-04 mtop-02" }

import { ref, computed } from 'vue';
import { useAppUserStore } from '@/stores/appUser';
import { getFlagEmojiForCountry } from "@/functions/geo.js";
import appuserapi from "@/api/appuserapi";
import { useI18n } from 'vue-i18n';
import ToggleSwitch from 'primevue/toggleswitch';



export default /*@__PURE__*/_defineComponent({
  __name: 'esMySettingsSettings',
  setup(__props) {

async function updateSuggestionsShowHumanBody(value: boolean) {
  await appuserapi.updateSuggestionsShowHumanBody(value)
  await appUserStore.setCurrentAppUserData()
}

async function updateSuggestionsShowNeuro(value: boolean) {
  await appuserapi.updateSuggestionsShowNeuro(value)
  await appUserStore.setCurrentAppUserData()
}

async function updateSuggestionsShowEnt(value: boolean) {
  await appuserapi.updateSuggestionsShowEnt(value)
  await appUserStore.setCurrentAppUserData()
}

async function updateSuggestionsShowLymph(value: boolean) {
  await appuserapi.updateSuggestionsShowLymph(value)
  await appUserStore.setCurrentAppUserData()
}

async function updateSuggestionsShowThorax(value: boolean) {
  await appuserapi.updateSuggestionsShowThorax(value)
  await appUserStore.setCurrentAppUserData()
}

async function updateSuggestionsShowAbdomen(value: boolean) {
  await appuserapi.updateSuggestionsShowAbdomen(value)
  await appUserStore.setCurrentAppUserData()
}

async function updateClinicalEntriesReducedByDefault(value: boolean) {
  await appuserapi.updateClinicalEntriesReducedByDefault(value)
  await appUserStore.setCurrentAppUserData()
}

const dropd = ref('')
const sctLanguageList = ref(['EnUs', 'EnGb', 'FrFr', 'DeDe', 'EsEs'])
const menuLanguageList = ref(['fr', 'en', 'de', 'es'])
const { t } = useI18n()

const appUserStore = useAppUserStore()

const user = computed(() => {
    if (!appUserStore.currentAppUserData) { return "" }
    const user = appUserStore.currentAppUserData
    return user
})

const suggestionsShowHumanBody = ref(user.value?.preferences?.suggestionsShowHumanBody ?? true)
const suggestionsShowNeuro = ref(user.value?.preferences?.suggestionsShowNeuro ?? true)
const suggestionsShowEnt = ref(user.value?.preferences?.suggestionsShowEnt ?? true)
const suggestionsShowLymph = ref(user.value?.preferences?.suggestionsShowLymph ?? true)
const suggestionsShowThorax = ref(user.value?.preferences?.suggestionsShowThorax ?? true)
const suggestionsShowAbdomen = ref(user.value?.preferences?.suggestionsShowAbdomen ?? true)
const clinicalEntriesReducedByDefault = ref(user.value?.preferences?.clinicalEntriesReducedByDefault ?? false)

const currSctLanguage = computed(() => {
  return user.value?.preferences?.sctLanguage || 'FrFr'
})

const currMenuLanguage = computed(() => {
  return user.value?.preferences?.menuLanguageIso || 'fr'
})

async function updateAppUserSctLanguage(sctLanguage: string) {
    dropd.value = ""
    await appuserapi.updateAppUserSctLanguage(sctLanguage)
    await appUserStore.setCurrentAppUserData()
}

async function updateAppUserMenuLanguage(menuLanguageIso: string) {
  dropd.value = ""
  console.log(menuLanguageIso)
//   updateI18nLocale(menuLanguageIso)
  await appuserapi.updateAppUserMenuLanguage(menuLanguageIso)
  await appUserStore.setCurrentAppUserData()
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)('settings.params.preferences.language.title')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.language.menus'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      (currMenuLanguage.value)
        ? (_openBlock(), _createBlock(_component_dropdownBox, {
            key: 0,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
            openOn: "MenuLanguage"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_dbGroup, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuLanguageList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_listGroup, {
                        key: index,
                        class: "pad-s row",
                        onClick: ($event: any) => (updateAppUserMenuLanguage(item))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(getFlagEmojiForCountry)(item)
                          }, null, 8, ["txt"]),
                          _createVNode(_component_text_item, {
                            txt: item,
                            class: "mleft-04"
                          }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                theme: "dropdown",
                styles: "border-vl pad-s"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(getFlagEmojiForCountry)(currMenuLanguage.value),
                    class: "mleft-04"
                  }, null, 8, ["txt"]),
                  _createVNode(_component_text_item, {
                    txt: currMenuLanguage.value,
                    styles: "font-m main-m",
                    class: "mleft-04"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.language.snomedct'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      (currSctLanguage.value)
        ? (_openBlock(), _createBlock(_component_dropdownBox, {
            key: 1,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
            openOn: "SctLanguage"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_dbGroup, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sctLanguageList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_listGroup, {
                        key: index,
                        class: "pad-s row",
                        onClick: ($event: any) => (updateAppUserSctLanguage(item))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(getFlagEmojiForCountry)(item.slice(2, 4))
                          }, null, 8, ["txt"]),
                          _createVNode(_component_text_item, {
                            txt: item,
                            class: "mleft-04"
                          }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, {
                theme: "dropdown",
                styles: "border-vl pad-s"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_text_item, {
                    txt: _unref(getFlagEmojiForCountry)(currSctLanguage.value.slice(2, 4)),
                    class: "mleft-04"
                  }, null, 8, ["txt"]),
                  _createVNode(_component_text_item, {
                    txt: currSctLanguage.value,
                    styles: "font-m main-m",
                    class: "mleft-04"
                  }, null, 8, ["txt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(t)('settings.params.preferences.suggestions.title')), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.suggestions.humanBody'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: suggestionsShowHumanBody.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((suggestionsShowHumanBody).value = $event)),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (updateSuggestionsShowHumanBody(suggestionsShowHumanBody.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.suggestions.neuro'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: suggestionsShowNeuro.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((suggestionsShowNeuro).value = $event)),
        onChange: _cache[5] || (_cache[5] = ($event: any) => (updateSuggestionsShowNeuro(suggestionsShowNeuro.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.suggestions.ent'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: suggestionsShowEnt.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((suggestionsShowEnt).value = $event)),
        onChange: _cache[7] || (_cache[7] = ($event: any) => (updateSuggestionsShowEnt(suggestionsShowEnt.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.suggestions.thorax'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: suggestionsShowThorax.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((suggestionsShowThorax).value = $event)),
        onChange: _cache[9] || (_cache[9] = ($event: any) => (updateSuggestionsShowThorax(suggestionsShowThorax.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.suggestions.abdomen'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: suggestionsShowAbdomen.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((suggestionsShowAbdomen).value = $event)),
        onChange: _cache[11] || (_cache[11] = ($event: any) => (updateSuggestionsShowAbdomen(suggestionsShowAbdomen.value)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.suggestions.lymph'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: suggestionsShowLymph.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((suggestionsShowLymph).value = $event)),
        onChange: _cache[13] || (_cache[13] = ($event: any) => (updateSuggestionsShowLymph(suggestionsShowLymph.value)))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)('settings.params.preferences.clinical.title')), 1),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('settings.params.preferences.clinical.reducedByDefault'),
        class: "mleft-04",
        styles: "font-m main-m"
      }, null, 8, ["txt"]),
      _createVNode(_unref(ToggleSwitch), {
        modelValue: clinicalEntriesReducedByDefault.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((clinicalEntriesReducedByDefault).value = $event)),
        onChange: _cache[15] || (_cache[15] = ($event: any) => (updateClinicalEntriesReducedByDefault(clinicalEntriesReducedByDefault.value)))
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}
}

})